import React, { useEffect, useState } from "react";
import { __ } from "services/Translator";
import { HeaderCarouselIcon, IconClover } from "components/header/HeaderCarouselIcons";

function CloverChasersFortuneMakers() {
  return (
    <span className="header-info-carousel__tagline">
      <strong>{__("CLOVER CHASERS")}</strong>
      <IconClover className="header-info-carousel__icon" />
      <strong>{__("FORTUNE MAKERS!")}</strong>
    </span>
  );
}

function renderCarouselIcon(item) {
  if (item.contentType === "clover-tagline") {
    return null;
  }
  return (
    <HeaderCarouselIcon
      type={item.iconType}
      className="header-info-carousel__icon"
    />
  );
}

function renderCarouselContent(item) {
  if (item.contentType === "clover-tagline") {
    return <CloverChasersFortuneMakers />;
  }
  return <span>{item.html()}</span>;
}

const HDR_INFO = [
  {
    key: "clover-chasers-1",
    iconType: "clover",
    contentType: "clover-tagline",
  },
  {
    key: "games",
    iconType: "slots",
    html: () => <strong>{__("OVER 8,000 CASINO GAMES")}</strong>,
  },
  {
    key: "clover-chasers-2",
    iconType: "clover",
    contentType: "clover-tagline",
  },
  {
    key: "deposit-bonus",
    iconType: "bonus",
    html: () => <strong>{__("DEPOSIT BONUSES TO THE MAX")}</strong>,
  },
  {
    key: "crash-games",
    iconType: "crash",
    html: () => <strong>{__("CRASH, SKILL, AND INSTANT GAMES")}</strong>,
  },
  {
    key: "clover-chasers-3",
    iconType: "clover",
    contentType: "clover-tagline",
  },
  {
    key: "cashback",
    iconType: "coins",
    html: () => <strong>{__("LOST TODAY? CASHBACK TOMORROW!")}</strong>,
  },
  {
    key: "support",
    iconType: "headphones",
    html: () => <strong>{__("24/7 HUMAN FRIENDLY SUPPORT")}</strong>,
  },
  {
    key: "clover-chasers-4",
    iconType: "clover",
    contentType: "clover-tagline",
  },
  {
    key: "live-tables",
    iconType: "blackjack",
    html: () => (
      <strong>{__("LIVE BLACKJACK, BACCARAT, ROULETTE")}</strong>
    ),
  },
  {
    key: "payouts",
    iconType: "zap",
    html: () => <strong>{__("LIGHTNING FAST PAYOUTS")}</strong>,
  },
  {
    key: "clover-chasers-5",
    iconType: "clover",
    contentType: "clover-tagline",
  },
  {
    key: "tournaments",
    iconType: "races",
    html: () => <strong>{__("BIG PRIZES WITH SLOTS TOURNAMENTS")}</strong>,
  },
  {
    key: "wheel",
    iconType: "wheel",
    html: () => <strong>{__("WHEEL OF FORTUNE GUARANTEES WINS")}</strong>,
  },
];

const HeaderInfoCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setActiveIndex((i) => (i + 1) % HDR_INFO.length);
    }, 3000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="header-info-carousel" id="hdrCarousel">
      {HDR_INFO.map((item, index) => (
        <span
          key={item.key}
          className={
            "header-info-carousel__item" +
            (item.contentType === "clover-tagline"
              ? " header-info-carousel__item--tagline"
              : "") +
            (index === activeIndex ? " header-info-carousel__item--on" : "")
          }
        >
          {renderCarouselIcon(item)}
          {renderCarouselContent(item)}
        </span>
      ))}
    </div>
  );
};

export default HeaderInfoCarousel;
